<template>
  <div>
    <highcharts ref="chart" :options="options" />
    <br />
    <b-table
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :data="values"
      :columns="columns"
    />
  </div>
</template>

<script>
import '@/plugins/highcharts.js'
import { useCoreStore } from '../../stores/core'

export default {
  name: 'TravelsModesPurposesDistancesBar',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  setup () {
    let coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    purposes: function () {
      return this.coreStore.travelPurposeLabels
    },
    values: function () {
      let values = []
      let distances = this.ghgi.emissions.travels.statuspurposes.distances
      for (let position of Object.keys(distances)) {
        let allPurposes = {}
        let i = 0
        for (let purpose of this.purposes) {
          allPurposes[this.$t(purpose)] =
            '<nobr>' +
            this.$options.filters.splitNumber(distances[position][i]) +
            '</nobr>'
          i += 1
        }
        allPurposes['position'] = '<nobr>' + this.$t(position) + '</nobr>'
        values.push(allPurposes)
      }
      return values
    },
    columns: function () {
      let columns = [
        {
          field: 'position',
          label: this.$t('position'),
          sticky: true
        }
      ]
      for (let purpose of this.purposes) {
        columns.push({
          field: this.$t(purpose),
          label: this.$t(purpose),
          numeric: true
        })
      }
      return columns
    },
    series: function () {
      let series = []
      for (let position of this.coreStore.travelPositionLabels) {
        let d = this.ghgi.emissions.travels.statuspurposes.distances[position]
        series.push({
          name: this.$t(position),
          data: d.map((value) => Math.round(value))
        })
      }
      return series
    },
    options: function () {
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        series: this.series,
        xAxis: {
          categories: this.purposes.map((val) => this.$t(val)),
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('distances.km')
          }
        },
        tooltip: {
          shared: true,
          valueSuffix: ' ' + this.$t('km')
        }
      }
    }
  }
}
</script>

<style>
.is-sticky {
  background: #fafafa !important;
}
.table td {
  vertical-align: middle !important;
}
</style>
